import { render, staticRenderFns } from "./getTicketDetails.vue?vue&type=template&id=123734a0&"
import script from "./getTicketDetails.vue?vue&type=script&lang=js&"
export * from "./getTicketDetails.vue?vue&type=script&lang=js&"
import style0 from "./getTicketDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports